import { createBigDecimal } from '@0xtorch/big-decimal'
import { z } from 'zod'

export const tradeSchema = z.object({
  /** trade id */
  trade_id: z.number().transform((v) => v.toString()),
  /** 通貨ペア */
  pair: z.string(),
  /** 注文ID */
  order_id: z.number(),
  side: z.union([z.literal('buy'), z.literal('sell')]),
  position_side: z
    .union([z.literal('long'), z.literal('short')])
    .nullable()
    .optional(),
  type: z.union([
    z.literal('limit'),
    z.literal('market'),
    z.literal('stop'),
    z.literal('stop_limit'),
  ]),
  /** 注文量 */
  amount: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** 価格 */
  price: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  maker_taker: z.union([z.literal('maker'), z.literal('taker')]),
  /** base手数料 */
  fee_amount_base: z
    .string()
    .regex(/^-?\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** quote手数料 */
  fee_amount_quote: z
    .string()
    .regex(/^-?\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** 実現損益 */
  profit_loss: z
    .string()
    .regex(/^-?\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v))
    .optional(),
  /** 利息 */
  interest: z
    .string()
    .regex(/^-?\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v))
    .optional(),
  /** 約定日時（UnixTimeのミリ秒） */
  executed_at: z.number(),
})

export type Trade = z.infer<typeof tradeSchema>
